import type { Project } from '@ponzinomics/types';
import { useProjectStore } from '../stores/project-store';

export function useCurrentProject(): { projectId: string | undefined; project: Project | null } {
  const currentProject = useProjectStore((s) => s.currentProject);
  return {
    projectId: currentProject?.id ?? undefined,
    project: currentProject,
  };
}
